module.exports = __webpack_public_path__ + "img/m_mainslide01.9303d5b5.jpg";